import { t } from 'i18next';
import * as yup from 'yup';

import { MaterialType } from '~hooks/useMaterials/models';
import UserStore from '~store/UserStore';

export const materialTypeSchema = yup.object().shape({
  company: yup
    .object()
    .shape({
      label: yup.string().trim().required(),
      value: yup.string().trim().required(),
    })
    .required(t('form_validation_errors.required_simple')),
  name: yup
    .string()
    .trim()
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
  externalId: yup.string().trim().notRequired(),
});

export type MaterialTypeDto = yup.InferType<typeof materialTypeSchema>;
export type MaterialTypeDtoAsyncError = {
  field: keyof MaterialTypeDto;
  message: string;
};

export function setMaterialTypeSchemaDefaultValues(
  userStore: UserStore,
  materialType?: MaterialType,
) {
  const initialCompany = userStore.currentCompanies[0] || userStore.user.company;

  const defaultValues: MaterialTypeDto = {
    company: { label: initialCompany.legalName, value: initialCompany.id },
    name: materialType?.name ?? '',
    externalId: materialType?.externalId ?? '',
  };

  return defaultValues;
}
